import * as React from 'react';
import { useSelector, useDispatch } from "react-redux";
import * as ModalActions from '../../store/Modal';
import { Typography, Dialog, Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListItemSecondaryAction, useTheme, Box, Stack, Snackbar } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ApplicationState } from '../../store';
import i18n from '../../i18n';


export default function Modal(props: any) {
    const { openModal, message, severity } = useSelector((state: ApplicationState) => state.modal);
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    i18n.changeLanguage(appLanguage);
    const theme = useTheme();
    const dispatch = useDispatch();
    const handleClose = () => (event: any) => {
        dispatch(ModalActions.actionCreators.setModalToClose());
        //Office.context.ui.closeContainer();

    }
    if (openModal) {
        setTimeout(() => {
            dispatch(ModalActions.actionCreators.setModalToClose());
        }, severity=="error"?100000:3000)
    }
    const getTitle = () => {
        switch (severity) {
            case "success":
                return i18n.t('app.success');
                break;
            case "warning":
                return "warning"
                break;
            case "error":
                return i18n.t('app.error');
                break;
            default: return "warning"; break;
        }
    }
    const getHeaderColor = () => {
        switch (severity) {
            case "success":
                return 'white';
                break;
            case "warning":
                return '#F39C12';
                break;
            case "error":
                return 'white';
                break;
            default: return '#23AE70'; break;
        }
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical:'top', horizontal:'center' }}
            onClose={handleClose} aria-labelledby="simple-dialog-title" open={openModal == null ? false : openModal}
            autoHideDuration={3000}        >
            <Box
                sx={{
                    [theme.breakpoints.down('sm')]: {
                        width: '100%',
                    },
                    [theme.breakpoints.up('sm')]: {
                        width: 'fit-content',
                        maxWidth: '365px',
                    },
                    paddingBottom: '10px',
                    overflow: 'hidden',
                    borderRadius: '5px',
                    display: 'flex',
                    flexDirection: 'column',
                    m: 'auto',
                    width: 'fit-content',
                    backgroundColor: theme.palette?.background.paper || '#fff',
                    padding: 'initial',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Stack sx={{ p: 2 }} spacing={2} alignItems="center">
                    <div style={{
                        backgroundColor: getHeaderColor(),
                        width: '100%',
                        padding: '10px',
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <img src={require(`../../assets/` + (severity === "success" ? 'successZ.svg' : 'errorZ.svg'))} style={{ width: '180px', height: '180px' }} />
                    </div>
                    <Typography variant="h6" textAlign="center" >{getTitle()}</Typography>
                    <Typography textAlign="center"> {message}</Typography>
                </Stack>
            </Box>
        </Snackbar>);
}